import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import ModalOverlay from "../modalOverlay/ModalOverlay";
import modalStyles from "./modal.module.css";
import i18n from "../../../i18n";
import { tWithKeyAttr as t } from "../../../i18nHelper";


interface IModal {
  children: JSX.Element;
  onClose: () => void;
  wide?: boolean;
}
const Modal = ({ children, onClose, wide }: IModal): JSX.Element => {
  const modalRoot = document.getElementById("modals") as HTMLDivElement;
    const lang = i18n.language || 'he';
    const baseLang = lang.split('-')[0]; // למשל "en-US" → "en"
    const dir = ['he', 'ar', 'fa', 'ur'].includes(baseLang) ? 'rtl' : 'ltr'; 


  return ReactDOM.createPortal(
    <>
      <div
        dir={dir}
        className={`${modalStyles.popupWindow} ${
          wide && modalStyles.popupWindow_type_wide
        }`}
      >
        <button
          className={modalStyles.popupWindow__closeBtn}
          data-testid="popup-close-button"
          onClick={() => {
            onClose();
          }}
        />
        <div className={modalStyles.popupWindow__content}>
          {children}
        </div>
      </div>
      <ModalOverlay onClick={() => {
        onClose();
      }} />
    </>,
    modalRoot
  );
};

export default Modal;
